import { Component, OnInit } from '@angular/core';
import { SECCIONES_107, HASH_CLAVE_GLOBAL, Seccion107, Archivo107 } from './resultados107.data';

const LLAVE_SESION = 'ly107_acceso';

@Component({
  selector: 'app-resultados107',
  templateUrl: './resultados107.component.html',
  styleUrls: ['./resultados107.component.css']
})
export class Resultados107Component implements OnInit {

  secciones = SECCIONES_107;
  seccionActiva: Seccion107 | null = null;
  archivoActivo: Archivo107 | null = null;

  mostrarModalClave = false;
  seccionPendiente: Seccion107 | null = null;
  clave = '';
  claveError = false;
  validando = false;

  pagina = 1;
  totalPaginas = 0;
  zoom = 1;
  cargandoPdf = false;
  errorPdf = false;

  private desbloqueadas: string[] = [];

  ngOnInit(): void {
    try {
      this.desbloqueadas = JSON.parse(sessionStorage.getItem(LLAVE_SESION) || '[]');
    } catch (e) {
      this.desbloqueadas = [];
    }
  }

  get zoomPorcentaje(): number {
    return Math.round(this.zoom * 100);
  }

  estaDesbloqueada(seccion: Seccion107): boolean {
    return this.desbloqueadas.indexOf('global') !== -1 || this.desbloqueadas.indexOf(seccion.id) !== -1;
  }

  abrirSeccion(seccion: Seccion107): void {
    if (this.estaDesbloqueada(seccion)) {
      this.activarSeccion(seccion);
    } else {
      this.seccionPendiente = seccion;
      this.clave = '';
      this.claveError = false;
      this.mostrarModalClave = true;
    }
  }

  cerrarModalClave(): void {
    this.mostrarModalClave = false;
    this.seccionPendiente = null;
  }

  async validarClave(): Promise<void> {
    if (!this.clave.trim() || this.validando || !this.seccionPendiente) { return; }
    this.validando = true;
    const hash = await this.sha256(this.clave.trim().toUpperCase());
    if (hash === HASH_CLAVE_GLOBAL) {
      this.desbloquear('global');
    } else if (hash === this.seccionPendiente.hashClave) {
      this.desbloquear(this.seccionPendiente.id);
    } else {
      this.claveError = true;
      this.validando = false;
      return;
    }
    const seccion = this.seccionPendiente;
    this.validando = false;
    this.mostrarModalClave = false;
    this.seccionPendiente = null;
    this.activarSeccion(seccion);
  }

  volverAlPortal(): void {
    this.seccionActiva = null;
    this.archivoActivo = null;
  }

  seleccionarArchivo(archivo: Archivo107): void {
    this.archivoActivo = archivo;
    this.pagina = 1;
    this.totalPaginas = 0;
    this.zoom = 1;
    this.cargandoPdf = true;
    this.errorPdf = false;
  }

  pdfCargado(pdf: any): void {
    this.totalPaginas = pdf.numPages;
    this.cargandoPdf = false;
  }

  pdfError(error: any): void {
    this.cargandoPdf = false;
    this.errorPdf = true;
  }

  paginaAnterior(): void {
    if (this.pagina > 1) { this.pagina--; }
  }

  paginaSiguiente(): void {
    if (this.pagina < this.totalPaginas) { this.pagina++; }
  }

  acercar(): void {
    if (this.zoom < 2.5) { this.zoom = Math.round((this.zoom + 0.25) * 100) / 100; }
  }

  alejar(): void {
    if (this.zoom > 0.5) { this.zoom = Math.round((this.zoom - 0.25) * 100) / 100; }
  }

  abrirEnPestana(): void {
    if (this.archivoActivo) { window.open(this.archivoActivo.ruta, '_blank'); }
  }

  private activarSeccion(seccion: Seccion107): void {
    this.seccionActiva = seccion;
    this.seleccionarArchivo(seccion.archivos[0]);
  }

  private desbloquear(id: string): void {
    if (this.desbloqueadas.indexOf(id) === -1) {
      this.desbloqueadas.push(id);
      sessionStorage.setItem(LLAVE_SESION, JSON.stringify(this.desbloqueadas));
    }
  }

  private sha256(texto: string): Promise<string> {
    const datos = new TextEncoder().encode(texto);
    return crypto.subtle.digest('SHA-256', datos).then((buffer) => {
      const bytes = new Uint8Array(buffer);
      let hex = '';
      for (let i = 0; i < bytes.length; i++) {
        hex += ('00' + bytes[i].toString(16)).slice(-2);
      }
      return hex;
    });
  }
}
